import React, { FunctionComponent } from "react";

import { useGetVehicleInfo } from "../../../queries/useGetVehicleInfo";
import { useSearchPartPackagesByVehicle } from "../../../queries/useSearchPartPackagesByVehicle";
import { VehicleHeader } from "../../VehicleHeader/VehicleHeader";
import { Visualizer } from "../../Visualizer/Visualizer";
import { shouldRenderVisualizer } from "../../Visualizer/shouldRenderVisualizer";
import { PackageFilters } from "../Filters/PackageFilters";
import { PackageList } from "./PackageList";

export const Packages: FunctionComponent = () => {
  const { data: vehicleInfo } = useGetVehicleInfo();
  const { data: parts, isLoading } = useSearchPartPackagesByVehicle();
  const hasVisualizer = shouldRenderVisualizer(vehicleInfo, parts?.length);
  return (
    <>
      {hasVisualizer ? null : (
        <VehicleHeader className="mt-4 md:mt-8 mb-2 flex-col items-start md:flex-row md:items-center">
          <PackageFilters
            className="md:self-end lg:mb-8 -my-1"
            isLoading={isLoading}
          />
        </VehicleHeader>
      )}
      {hasVisualizer && (
        <Visualizer
          className="mt-4"
          controls={<PackageFilters isLoading={isLoading} />}
          parts={parts || null}
          vehicleInfo={vehicleInfo || null}
        />
      )}
      <PackageList
        hasVisualizer={hasVisualizer}
        parts={parts}
        vehicleInfo={vehicleInfo}
      />
    </>
  );
};
